import React from "react";
import {
  CfcDetailBanner,
  CfcDetailBannerCopy,
  CfcDetailBannerOrderButton,
  CfcDetailBannerStrong,
} from "./CfcDetailEligibilityBanner.styles";
import { formatCfcCollectByDate } from "./cfcGridUtils";

interface CfcDetailEligibilityBannerProps {
  cfcEligibleCollectByDate: string | null;
  onOrderCfc: () => void;
}

const getCfcDeadlineMessage = (collectByDate: string): string =>
  `Test order and additional blood draw must be completed no later than ${collectByDate}`;

export const CfcDetailEligibilityBanner = ({
  cfcEligibleCollectByDate,
  onOrderCfc,
}: CfcDetailEligibilityBannerProps): React.ReactElement => {
  const collectByDate = formatCfcCollectByDate(cfcEligibleCollectByDate);

  return (
    <CfcDetailBanner>
      <CfcDetailBannerCopy>
        <div>
          Eligible for Unity Confirm<sup>TM</sup>, circulating fetal cell
          confirmatory testing.
        </div>
        <CfcDetailBannerStrong>
          {getCfcDeadlineMessage(collectByDate)}
        </CfcDetailBannerStrong>
      </CfcDetailBannerCopy>
      <CfcDetailBannerOrderButton onClick={onOrderCfc}>
        ORDER TEST
      </CfcDetailBannerOrderButton>
    </CfcDetailBanner>
  );
};
